import axios from 'axios';
import config from './config';
import { util, lg } from 'utils';

let base = util.getDomain();
//拉取组织架构列表
export const GetDepartmentList = params => { return axios.get(`${base}/api/Department/GetDepartmentList`,{ params: params }); };
//添加机构部门
export const AddDepartment= params => { return axios.post(`${base}/api/Department/AddDepartment`,params,config); };
//删除机构部门
export const DelDepartment= params => { return axios.post(`${base}/api/Department/DelDepartment`,params,config); };
//单条机构部门
export const GetDepartmentById = params => { return axios.get(`${base}/api/Department/GetDepartmentById`,{ params: params }); };
//更新数据
export const UpdateDepartment= params => { return axios.post(`${base}/api/Department/UpdateDepartment`,params,config); };


// WEBPACK FOOTER //
// ./src/api/organization.js